module.exports = __webpack_public_path__ + "img/COMBO WAVES LIME.141a556.svg";